<template>
  <slot-master :show-modal="true" @update:showModal="onToggle" />
</template>

<script>
import slotMaster from './slotMaster.vue'

export default {
  name: 'ServiceBookings',
  components: { slotMaster },
  methods: {
    onToggle(val) {
      if (!val) {
        this.$router.push('/gurudwara/list').catch(() => {})
      }
    }
  }
}
</script>
